import type { MarketingCampaign } from '@/api/marketing.api';
import { TableRowActions } from '@/components/ui/TableRowActions';
import { Button } from '@/components/ui/Button';

type Handlers = {
  onStats: (c: MarketingCampaign) => void;
  onClone: (id: number) => void;
  onSubmit: (id: number) => void;
  onApprove: (id: number) => void;
  onSchedule: (c: MarketingCampaign) => void;
  onLaunch: (id: number) => void;
  onComplete: (id: number) => void;
  onArchive: (id: number) => void;
};

type Props = {
  campaign: MarketingCampaign;
  handlers: Handlers;
};

export function CampaignRowActions({ campaign, handlers }: Props) {
  const s = campaign.lifecycleStatus;
  const terminal = ['ARCHIVED', 'COMPLETED'].includes(s);

  return (
    <TableRowActions layout="wrap">
      <Button variant="ghost" size="sm" onClick={() => handlers.onStats(campaign)}>
        Stats
      </Button>
      <Button variant="ghost" size="sm" onClick={() => handlers.onClone(campaign.id)}>
        Clone
      </Button>
      {s === 'DRAFT' && (
        <Button variant="ghost" size="sm" onClick={() => handlers.onSubmit(campaign.id)}>
          Submit
        </Button>
      )}
      {s === 'REVIEW' && (
        <Button variant="ghost" size="sm" onClick={() => handlers.onApprove(campaign.id)}>
          Approve
        </Button>
      )}
      {(s === 'APPROVED' || s === 'SCHEDULED') && (
        <>
          {s === 'APPROVED' && (
            <Button variant="ghost" size="sm" onClick={() => handlers.onSchedule(campaign)}>
              Schedule
            </Button>
          )}
          <Button variant="ghost" size="sm" className="text-emerald-700 dark:text-emerald-300" onClick={() => handlers.onLaunch(campaign.id)}>
            Launch
          </Button>
        </>
      )}
      {s === 'RUNNING' && (
        <Button variant="ghost" size="sm" onClick={() => handlers.onComplete(campaign.id)}>
          Complete
        </Button>
      )}
      {!terminal && (
        <Button variant="ghost" size="sm" onClick={() => handlers.onArchive(campaign.id)}>
          Archive
        </Button>
      )}
    </TableRowActions>
  );
}
